import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const email = searchParams.get('email');
  
  const navigate = useNavigate();
  const [passwords, setPasswords] = useState({
    password: '',
    confirmPassword: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setPasswords({
      ...passwords,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (passwords.password !== passwords.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    if (passwords.password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }

    if (!token || !email) {
      setError('Invalid or missing reset token/email parameters.');
      return;
    }

    setIsSubmitting(true);

    try {
      const apiUrl = 'https://naus-backend.onrender.com/api';
      await axios.post(`${apiUrl}/auth/reset-password`, {
        email,
        token,
        newPassword: passwords.password
      });
      setSuccess(true);
      setTimeout(() => navigate('/member-login'), 3000);
    } catch (error) {
      if (error.response) {
        setError(error.response.data.message || 'An error occurred. Please try again.');
      } else if (error.request) {
        setError('Cannot connect to server. Please check your connection and try again.');
      } else {
        setError('An error occurred. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  // Guard clause if user visits /reset-password directly without token/email query params
  if (!token || !email) {
    return (
      <div className="section">
        <div className="container">
          <div style={{
            backgroundColor: 'var(--white)',
            padding: '2rem',
            borderRadius: '8px',
            boxShadow: 'var(--shadow)',
            maxWidth: '400px',
            margin: '2rem auto',
            textAlign: 'center'
          }}>
            <h2 style={{ color: '#721c24', marginBottom: '1rem' }}>Invalid Reset Link</h2>
            <p style={{ color: '#666', marginBottom: '1.5rem' }}>
              This password reset link is missing required verification parameters.
            </p>
            <Link
              to="/forgot-password"
              className="btn"
              style={{
                display: 'inline-block',
                padding: '0.75rem 1.5rem',
                textDecoration: 'none'
              }}
            >
              Request New Link
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="section">
      <div className="container">
        <div style={{
          backgroundColor: 'var(--white)',
          padding: '2rem',
          borderRadius: '8px',
          boxShadow: 'var(--shadow)',
          maxWidth: '400px',
          margin: '2rem auto'
        }}>
          <h2 style={{ color: 'var(--primary-green)', textAlign: 'center', marginBottom: '1.5rem' }}>
            Reset Password
          </h2>

          {success ? (
            <div>
              <div style={{
                backgroundColor: '#d4edda',
                color: '#155724',
                padding: '1rem',
                borderRadius: '4px',
                marginBottom: '1rem',
                textAlign: 'center'
              }}>
                <p style={{ marginBottom: '0.5rem', fontWeight: 'bold' }}>Password Reset Successful!</p>
                <p style={{ margin: 0, fontSize: '0.9rem' }}>
                  Redirecting you to login...
                </p>
              </div>
              <Link
                to="/member-login"
                className="btn"
                style={{
                  display: 'block',
                  width: '100%',
                  padding: '1rem',
                  fontSize: '1.1rem',
                  textAlign: 'center',
                  textDecoration: 'none',
                  boxSizing: 'border-box'
                }}
              >
                Go to Login
              </Link>
            </div>
          ) : (
            <>
              <p style={{ color: '#666', textAlign: 'center', marginBottom: '1.5rem' }}>
                Enter your new password below.
              </p>

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '1rem' }}>
                  <label htmlFor="password" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                    New Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={passwords.password}
                    onChange={handleChange}
                    required
                    placeholder="Enter new password"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      fontSize: '1rem',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>

                <div style={{ marginBottom: '1rem' }}>
                  <label htmlFor="confirmPassword" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                    Confirm New Password
                  </label>
                  <input
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={passwords.confirmPassword}
                    onChange={handleChange}
                    required
                    placeholder="Confirm new password"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      fontSize: '1rem',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>

                {error && (
                  <div style={{
                    backgroundColor: '#f8d7da',
                    color: '#721c24',
                    padding: '0.75rem',
                    borderRadius: '4px',
                    marginBottom: '1rem'
                  }}>
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn"
                  style={{
                    width: '100%',
                    padding: '1rem',
                    fontSize: '1.1rem',
                    cursor: isSubmitting ? 'not-allowed' : 'pointer'
                  }}
                >
                  {isSubmitting ? 'Resetting...' : 'Reset Password'}
                </button>
              </form>

              <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
                <Link
                  to="/member-login"
                  style={{
                    color: 'var(--primary-green)',
                    textDecoration: 'none',
                    fontWeight: 'bold'
                  }}
                >
                  Back to Login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;